import React from "react"

import { Button } from "@coval/ui"
import { ChartColumnIncreasing } from "lucide-react"

import { EmptyStateActions } from "@/components/EmptyStateCTA"

import { GRID_CONFIG } from "../widgets/utils/gridMetrics"

interface EmptyDashboardStateProps {
  onAddWidget: () => void
}

/** Default widget size: 12 cols x 4 rows; 12/48 of a 1200px container ≈ 300px wide */
const DEFAULT_WIDGET_HEIGHT_PX = 4 * GRID_CONFIG.ROW_HEIGHT
const DEFAULT_WIDGET_WIDTH_PX = 300

export const EmptyDashboardState: React.FC<EmptyDashboardStateProps> = ({
  onAddWidget,
}) => {
  return (
    <div
      className="flex items-center justify-center bg-surface-default backdrop-blur-sm rounded-sm border border-coval-border shadow-none p-3"
      style={{
        width: DEFAULT_WIDGET_WIDTH_PX,
        minHeight: DEFAULT_WIDGET_HEIGHT_PX,
      }}
    >
      <div className="text-center w-full p-4">
        <ChartColumnIncreasing
          className="w-12 h-12 text-coval-text-muted mx-auto mb-4"
          strokeWidth={1.5}
        />

        <p className="text-coval-text mb-4">
          Add your first widget to get started with your dashboard
        </p>
        <EmptyStateActions>
          <Button
            aria-label="Add widget"
            data-testid="dashboard-add-widget-button"
            onClick={onAddWidget}
          >
            Add Widget
          </Button>
        </EmptyStateActions>
      </div>
    </div>
  )
}
